import { useMutation } from "@tanstack/react-query"
import { createSocialPost } from "../services/social-publish.service"
import type { CreateSocialPostRequest } from "../types/social-publish.types"

export function useCreateSocialPost() {
  return useMutation({
    mutationFn: async (params: { data: CreateSocialPostRequest; idempotencyKey: string }) => {
      return createSocialPost(params.data, params.idempotencyKey)
    },
  })
}
